import {Switch as AntdSwitch} from 'antd';

const Switch = ({
  initialValue,
  ...props
}) => (
  <AntdSwitch checked={initialValue} {...props}/>
);

export default Switch;
